<template>
  <div class="fill-height primary">
    <v-content class="fill-height">
      <v-layout align-center justify-center row wrap fill-height>
        <v-flex
          xs12
          layout
          align-center
          justify-center
          pa-3
        >
          <v-container fluid grid-list-xs class="pa-2">
            <v-layout row wrap>
              <v-flex xs12 sm12 offset-md3 md6 offset-lg4 lg4>
                <v-card class="pl-4 pr-4 pb-4 pt-0 elevation-5">
                  <v-card-title primary-title>
                    <v-container grid-list-md class="pa-0">
                      <v-layout row wrap>
                        <v-flex
                          xs12
                          text-xs-center
                          layout
                          align-center
                          justify-center
                        >
                          <v-avatar
                            size="150"
                            color="white"
                            tile
                          >
                            <img :src="logoUrl">
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-title>
                  <v-form ref="form" v-model="frmValid">
                    <v-text-field
                      v-model="txtEmail"
                      :rules="emailRules"
                      label="E-mail"
                      solo
                      @keyup.enter="(frmValid ? login() : '')"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="txtPassword"
                      :rules="passwordRules"
                      label="Password"
                      :type="'password'"
                      solo
                      @keyup.enter="(frmValid ? login() : '')"
                      required
                    ></v-text-field>
                    <v-btn
                      block
                      color="primary"
                      large
                      :disabled="!frmValid"
                      @click="login"
                    >
                      Login
                    </v-btn>
                  </v-form>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}

.fill-height {
  height: 100%;
}

.fill-width {
  width: 100%;
}

.pa-3 {
  padding: 5px;
}

</style>

<script>
import router from '../router'
import Loading from '@/components/Loading.vue'

export default {
  components: {
    Loading
  },
  data () {
    return {
      logoUrl: process.env.VUE_APP_LOGO_URL,
      loading: false,
      frmValid: false,
      txtPassword: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6) || 'Password must be more than 6 characters'
      ],
      txtEmail: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ]
    }
  },

  methods: {
    login: function () {
      this.loading = true
      const loginEmail = this.txtEmail
      const password = this.txtPassword
      this.$store.dispatch('AUTH_REQUEST', { loginEmail, password }).then(() => {
        if (typeof this.$route.query.next !== 'undefined' && this.$route.query.next.length > 0 && this.$route.query.next.substr(0, 6) !== '/login') {
          router.push(this.$route.query.next)
        } else {
          let userProfile = this.getUserProfile()
          let accessProduct = false
          let accessSales = false

          for (let i = 0, len = userProfile.permissions.length; i < len; i++) {
            if (userProfile.permissions[i].permissionId === 'PEM-SALES' && userProfile.permissions[i].isRead === '1') {
              accessSales = true
            }
            if (userProfile.permissions[i].permissionId === 'PEM-PRODUCT' && userProfile.permissions[i].isRead === '1') {
              this.accessProduct = true
            }
          }
          if (accessSales) {
            router.push('/orders/in-progress')
          } else if (accessProduct) {
            router.push('/products')
          } else {
            router.push('/tickets/pending')
          }
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
      })
    }
  }
}
</script>
